import { UserDetailsContext } from 'context/userDetailsContext';
import { useState, useCallback, useEffect, useContext } from 'react';
import { getMessages } from 'services/messages/messageService';
import { getTenantIdFromLS, getTenantSkFromLS } from 'utils/localStorageUtils';

export const useSecureMessages = ({
  case_id,
  isLeadSpecific = false,
  isFromCaseSpecificModule = false,
  isGlobalMessagesScreen = false,
  page_limit = 100,
  resolution_status = false,
}) => {
  const userContext = useContext(UserDetailsContext);
  const tenantId = getTenantIdFromLS();
  const tenant_sk = getTenantSkFromLS();
  const tenantSk = tenant_sk ? tenant_sk.replaceAll('#', '%23') : '';

  const [caseSecureMessages, setCaseSecureMessages] = useState([]);
  const [pageLimit, setpageLimit] = useState(getPageLimit() ?? page_limit);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  function getPageLimit() {
    if (isLeadSpecific && userContext) {
      return userContext?.firmDetails?.pagination_preference?.leads?.message;
    } else if (isFromCaseSpecificModule && userContext) {
      return userContext?.firmDetails?.pagination_preference?.case?.message;
    } else if (isGlobalMessagesScreen && userContext) {
      return userContext?.firmDetails?.pagination_preference?.messages?.self;
    }
  }

  const loadCaseSecureMessages = useCallback(
    async (obj = {}) => {
      setLoading(true);
      setError(null);

      try {
        obj.case_id = case_id;
        obj.is_global = isGlobalMessagesScreen ? true : false;
        obj.pageLimit = pageLimit;
        obj.tenantId = tenantId;
        obj.tenantSk = tenantSk;
        obj.is_read = obj?.is_read ?? '';
        obj.author_id = obj?.author_id ?? '';
        obj.resolution_status = resolution_status ?? false;

        const response = await getMessages(obj);

        setCaseSecureMessages(response.data?.message || []);
      } catch (err) {
        console.error(err);
        setError(err);
      } finally {
        setLoading(false);
      }
    },
    [case_id, isLeadSpecific, isGlobalMessagesScreen, tenantId, tenantSk]
  );

  useEffect(() => {
    if (case_id || isGlobalMessagesScreen) {
      loadCaseSecureMessages();
    }
  }, [case_id, isGlobalMessagesScreen, loadCaseSecureMessages]);

  return {
    loadCaseSecureMessages,
    caseSecureMessages,
    loading,
    error,
  };
};
